import { render, staticRenderFns } from "./select-field.vue?vue&type=template&id=1dfd1a9a"
import script from "./select-field.vue?vue&type=script&lang=js"
export * from "./select-field.vue?vue&type=script&lang=js"
import style0 from "./select-field.vue?vue&type=style&index=0&id=1dfd1a9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports